import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const Icon = ({ children }) => (
  <span className="fi-ic">
    <svg viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
  </span>
);

const TOOLS = [
  { tone: 'ye', to: '/deal-checker', event: 'home_tool_deal_checker', title: 'Deal-Checker', blurb: 'Paste your dealer quote. We flag the junk fees. Nothing stored.', go: 'Check my quote', icon: <><path d="M6 2h12v20l-3-2-3 2-3-2-3 2z" /><path d="M9 7h6M9 11h6M9 15h3" /></> },
  { tone: 'gr', to: '/find-your-ev', event: 'home_tool_find_ev', title: 'Find your EV', blurb: 'The EVs you can buy in the US, matched to your life and budget.', go: 'Match me', icon: <><path d="M5 17h14v-5l-2-5H7l-2 5z" /><circle cx="8" cy="17" r="2" /><circle cx="16" cy="17" r="2" /><path d="M5 12h14" /></> },
  { tone: 'sk', to: '/savings-calculator', event: 'home_tool_savings', title: 'Savings calculator', blurb: "Your miles, your gas price, your power rate. What you'd actually save.", go: 'Do the math', icon: <><rect x="5" y="2" width="14" height="20" rx="2" /><path d="M8 6h8M8 11h2M14 11h2M8 15h2M14 15h2M8 18h2M14 18h2" /></> },
  { tone: 'or', to: '/incentives', event: 'home_tool_incentives', title: 'Incentives near you', blurb: "The federal credit is gone. Here's what your state and utility still pay.", go: 'Check my state', icon: <><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" /><circle cx="12" cy="10" r="2.5" /></> },
  { tone: 'wh', to: '/dealership-survival-kit', event: 'home_tool_survival', title: 'Survival Kit', blurb: 'Every junk fee to refuse and what to actually pay. Free PDF.', go: 'Get the kit', icon: <><path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" /><path d="M8.5 12l2.5 2.5 4.5-5" /></> },
  { tone: 'rd', to: '/brief', event: 'home_tool_brief', title: 'This week in EVs', blurb: 'A short, no-BS digest of the EV news that matters. Mondays.', go: 'Read the brief', icon: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M7 9h10M7 13h10M7 17h6" /></> },
];

export default function ToolsWall() {
  return (
    <section className="fi-tools-sec" id="tools" aria-labelledby="fi-tools-h">
      <div className="fi-wrap">
        <h2 className="fi-h2" id="fi-tools-h">Tools for the recovering idiot</h2>
        <p className="fi-sub">Free, no account, nothing to install. Pick the one that matches where you are.</p>
        <div className="fi-twall" data-track-context="home_tools">
          {TOOLS.map((t) => (
            <RouterLink key={t.to} to={t.to} className={`fi-tool fi-t-${t.tone}`} onClick={() => { if (window.gtag) window.gtag('event', t.event, {}); }}>
              <Icon>{t.icon}</Icon>
              <h3>{t.title}</h3>
              <p>{t.blurb}</p>
              <span className="fi-go">{t.go} &rarr;</span>
            </RouterLink>
          ))}
        </div>
      </div>
    </section>
  );
}
